export enum RoleMemberType {
    MyKonicaMinoltaPerson = 5,
    MyKonicaMinoltaJobCode = 6,
};

export const RoleMemberTypeDisplayName: Record<RoleMemberType, string> = {
    [RoleMemberType.MyKonicaMinoltaJobCode]: "MKM Job Code",
    [RoleMemberType.MyKonicaMinoltaPerson]: "MKM Person",
};